<h1 mat-dialog-title>{{ title }}</h1>
<div
  [innerHTML]="htmlData"
  mat-dialog-content></div>
